/* eslint-disable no-unused-vars */
import { call, put, select } from 'redux-saga/effects';

import request from '../request';
import { pathSelector } from '../../../selectors';
import { fetchCustomers, searchCustomers } from '../../../actions';
import api from '../../../api';

export function* searchCustomersService(groupId, query) {
  yield put(searchCustomers(groupId, query));

  // let customers;
  // let sellitems;
  // let addresses;
  // let payments;

  // try {
  //   ({
  //     items: customers,
  //     included: { sellitems, addresses, payments },
  //   } = yield call(request, api.searchCustomers, groupId, {
  //     query,
  //   }));
  // } catch (error) {
  //   yield put(searchCustomers.failure(groupId, error));
  //   return;
  // }

  // yield put(searchCustomers.success(groupId, customers, sellitems, addresses, payments));
}

export function* searchCustomersInCurrentGroupService(query) {
  const { groupId } = yield select(pathSelector);

  yield call(searchCustomersService, groupId, query);
}

export function* fetchCustomersService(groupId, query) {
  yield put(fetchCustomers(groupId, query));

  let customers;
  let sellitems;
  let addresses;
  let payments;

  try {
    ({
      items: customers,
      included: { sellitems, addresses, payments },
    } = yield call(request, api.searchCustomers, groupId, {
      query,
    }));
  } catch (error) {
    yield put(searchCustomers.failure(groupId, error));
    return;
  }

  yield put(searchCustomers.success(groupId, customers, sellitems, addresses, payments));
}

export function* fetchCustomersInCurrentGroupService(query) {
  const { groupId } = yield select(pathSelector);

  yield call(fetchCustomersService, groupId, query);
}
